import React from 'react';
import { ModalProps } from '@features/Modal';
import { Table } from '@features/Table';
import { Button } from '@shared/UI';
import { useModal } from '@features/Modal/lib/ModalProvider';
import { ITradeBreak } from './lib/interfaces';
import { getTradeBreaksTableColumns } from './lib';
import { TimelineActions } from '@widgets/Timeline/components';
import { IStatus } from '@shared/api';
import './TradeBreaksModal.scss';

interface ITradeBreaksModalProps extends ModalProps {
    parsedAdditionalData?: {
        TradeBreaks?: ITradeBreak[];
        ErrorMessages?: string;
    };
    currentSettlement: IStatus;
}

export const TradeBreaksModal: React.FC<ITradeBreaksModalProps> = (props) => {
    const { currentSettlement, parsedAdditionalData } = props;
    const { removeModal } = useModal();

    const tradeBreaks = parsedAdditionalData?.TradeBreaks;

    return (
        <div className='widget-trade-breaks-modal'>
            <div className='widget-trade-breaks-modal__header'>
                <h3 className='widget-trade-breaks-modal__title'>{tradeBreaks?.length ? 'Trade Breaks' : 'Error'}</h3>
            </div>
            <div className='widget-trade-breaks-modal__content'>
                <div className='widget-trade-breaks-modal__content__warning'>
                    <etna-icon name={'Warning'} />
                    <div className='widget-trade-breaks-modal__content__warning__info'>
                        {tradeBreaks?.length ? (
                            <>
                                <h5>
                                    Clearing has detected discrepancies between the transactions reported by the OMS,
                                    execution venue, and DTC.
                                </h5>
                                <p>
                                    Certain transactions are missing in some of the reports while others have a price or
                                    quantity mismatch. Investigate the root cause of the discrepancies, resolve them
                                    with the corresponding parties, and subsequently restart the report reconciliation
                                    step.
                                </p>
                            </>
                        ) : (
                            <h5>
                                {parsedAdditionalData?.ErrorMessages
                                    ? parsedAdditionalData.ErrorMessages
                                    : 'No specific error message was returned by the server'}
                            </h5>
                        )}
                    </div>
                </div>
                {!!tradeBreaks?.length && (
                    <Table
                        columns={getTradeBreaksTableColumns()}
                        data={tradeBreaks}
                    />
                )}
                <div className='widget-trade-breaks-modal__content__buttons-container'>
                    <Button
                        className='widget-trade-breaks-modal__content__buttons-container__cancel'
                        onClick={removeModal}
                    >
                        Cancel
                    </Button>
                    <TimelineActions
                        status={currentSettlement}
                        callback={removeModal}
                    />
                </div>
            </div>
        </div>
    );
};
